import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref } from 'vue';
import store from '@/store';
import { CombinedPresets, ImageEffectPreset } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import { isTextToImageEffect } from '@/typings/customilyElements/imageEffectType';
import BodyPresetGridThumbnail from '@/components/DesignStudio/ImageEffectsProperties/components/create/components/body/preset/grid/thumbnail/BodyPresetGridThumbnail.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BodyPresetGrid',
  setup(__props) {

const selectedPreset = computed(() => store.getters['imageEffectsProperties/selectedPreset']);
const groupedPresets = computed(() => store.getters['imageEffectsProperties/groupedFilteredPresets']);
const hasTextToImageEffect = inject('hasTextToImageEffect', ref(false));

const handlePresetSelect = (preset: ImageEffectPreset) => {
    store.dispatch('imageEffectsProperties/selectImageEffect', preset);
};

const isDisabledPreset = (preset: CombinedPresets) => {
    const type = preset.presets?.[0]?.effectConfig?.type;
    return hasTextToImageEffect.value && !!type && isTextToImageEffect(type);
};

return { __sfc: true,selectedPreset, groupedPresets, hasTextToImageEffect, handlePresetSelect, isDisabledPreset, BodyPresetGridThumbnail }
}

})